// PRICING CAMARAS
{/*export const price12Cam = 800;
export const price11Cam = 810; //
export const price10Cam = 820; //
export const price9Cam = 825;
export const price8Cam = 850; //
export const price7Cam = 950; //
export const price6Cam = 1012;
export const price5Cam = 1118; //
export const price4Cam = 1122; //
export const price3Cam = 1228;
export const price2Cam = 1400; //
export const price1Cam = 1600;*/}

export const price12Cam = 672;  // 8064 / 12
export const price11Cam = 672;  // (Estimado proporcionalmente)
export const price10Cam = 672;  // (Estimado proporcionalmente)
export const price9Cam = 693;   // 6237 / 9
export const price8Cam = 771;   // (Interpolación sugerida entre 6 y 9 cams)
export const price7Cam = 812;   // (Interpolación sugerida entre 6 y 9 cams)
export const price6Cam = 850; // 5103 / 6
export const price5Cam = 942;   // (Interpolación sugerida entre 3 y 6 cams)
export const price4Cam = 981;   // (Interpolación sugerida entre 3 y 6 cams)
export const price3Cam = 1032; // 3095 / 3
export const price2Cam = 1188;  // (Interpolación sugerida entre 1 y 3 cams)
export const price1Cam = 1344;  // Valor directo de la tabla

/* OLD
export const price12Cam = 960;
export const price11Cam = 972; //
export const price10Cam = 984; //
export const price9Cam = 990;
export const price8Cam = 1020; //
export const price7Cam = 1140; //
export const price6Cam = 1215;
export const price5Cam = 1342; //
export const price4Cam = 1347; //
export const price3Cam = 1474;
export const price2Cam = 1680; //
export const price1Cam = 1920;
*/

// PRICING LICENCES
{/*export const price1slotLicence = 1000; //
export const price2slotLicence = 1200; //
export const price3slotLicence = 1800;
export const price4slotLicence = 2400; //
export const price5slotLicence = 2900; //
export const price6slotLicence = 3400;
export const price7slotLicence = 3900; //
export const price8slotLicence = 4400; //
export const price9slotLicence = 4500;
export const price10slotLicence = 5000; //
export const price11slotLicence = 5250; //
export const price12slotLicence = 5500;*/}

export const price1slotLicence = 1200; //
export const price2slotLicence = 1440; //
export const price3slotLicence = 2160;
export const price4slotLicence = 2880; //
export const price5slotLicence = 3480; //
export const price6slotLicence = 4080;
export const price7slotLicence = 4680; //
export const price8slotLicence = 5280; //
export const price9slotLicence = 5400;
export const price10slotLicence = 6000; //
export const price11slotLicence = 6300; //
export const price12slotLicence = 6600;


// PRICING EXTENSIONS LICENCES
{/*export const price1yearExtension = 1000;
export const price2yearExtension = 1800;
export const price3yearExtension = 2200;*/}

export const price1yearExtension = 1200;
export const price2yearExtension = 2160;
export const price3yearExtension = 2640;


// PRICING DISCOUNT COUPONS
        // Bonificacion por presentarte a la reunión. (-200 U$D)
export const P0M0C2 = 200;
        //USD 50 → 
export const LSLSTART = 50;
        //USD 100 → 
export const LSLDOBLE = 100;        
        //USD 250 → 
export const LSLOFF = 250;
        //USD 500 → 
export const LSLOFFDOBLE = 500; //500 //test3399
        //USD 750 → 
export const LSLTOP = 750;
        //USD 1000 → 
export const LSLWIN = 2000;
        //test
export const uoiaud981ujd9q8uosd0j1oijwed09wudj0so0iud9812uejdoisud9o = 3399        


//PRICING SINGLE CAMS
export const priceSingleCam = 1560 //1300; //1300


